// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchBar_wrapper__RBzHm","wrapperInner":"SearchBar_wrapperInner__1HipY","wrapperLoop":"SearchBar_wrapperLoop__1YVe-","span":"SearchBar_span__29FRy"};